import Quill from 'quill'

tag single-note
	css 
		div
			h:100% min-height:91vh
			&:focus bd:none outline:none pos:relative
		
		.editable p:8

		button
			px:6 py:4 pos:absolute r:0 b:0 bgc:gray2 bd:none


	quill\Quill

	def mount
		quill = new Quill('.editable', {
			theme: 'bubble'
		});
		quill.root.innerHTML = state.currentNote.data
	

	def rendered
		quill && quill.root.innerHTML = state.currentNote.data
	
	
	def saveNote
		console.log 'saving'
		const data = quill.root.innerHTML
		const title = quill.getText().slice(0, 15).trim() + '...'
		const note = {...state.currentNote, title, data, id: state.currentNote.id}
		emit('saveNote', note)

		

	<self>
		<div .editable @keyup.debounce(5s)=saveNote>
		<button @click=saveNote> "Save"
